module.exports = __webpack_public_path__ + "media/images/pic/courses/group-teacher-right-105e129c1de1a0a09346057a5e818131.png";